<div class="row icon-container-parent">
  <div class="icon-container">
    <div class="mw xl-12 md-12 sm-12 xs-12">
      <div class="image-container">
        <div class="image mobile-hide">
          <a href="/terms-conditions/" target="_blank" rel="nofollow">
            <img [src]="'/assets/images/icons/18+.png'" [srcset]="'/assets/images/icons/18+@2x.png 2x'">
          </a>
        </div>
        <div class="image mobile-show image-18">
          <img [src]="'/assets/images/icons/18+mobile.png'" [srcset]="'/assets/images/icons/18+mobile@2x.png 2x'">
        </div>
        <div class="image image-problem">
          <a href="http://www.gamcare.org.uk/" target="_blank" rel="nofollow">
            <img [src]="'/assets/images/icons/problem.png'" [srcset]="'/assets/images/icons/problem@2x.png 2x'">
          </a>
        </div>
        <div class="image image-iom">
          <a *ngIf="brand === 'qiwi'" href="http://www.gov.im/gambling/licensees/" target="_blank" rel="nofollow">
            <img [src]="'/assets/images/icons/iom.png'" [srcset]="'/assets/images/icons/iom@2x.png 2x'">
          </a>
          <a *ngIf="brand === 'winaija'" href="https://lslb.lg.gov.ng/" target="_blank" rel="nofollow">
            <img [src]="'/assets/images/icons/lslb.png'" />
          </a>
        </div>
        <div class="image mobile-show image-secure">
          <img [src]="'/assets/images/icons/securemobile.png'" [srcset]="'/assets/images/icons/securemobile@2x.png 2x'">
        </div>
        <div class="image image-ibas">
          <a href="http://www.ibas-uk.com/" target="_blank" rel="nofollow">
            <img [src]="'/assets/images/icons/ibas_logo.png'" [srcset]="'/assets/images/icons/ibas_logo@2x.png 2x'">
          </a>
        </div>
        <div class="image mobile-hide image-secure">
          <a href="https://www.comodo.com/" target="_blank" rel="nofollow">
          <img [src]="'/assets/images/icons/secure.png'" [srcset]="'/assets/images/icons/secure@2x.png 2x'">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
